/** Strings owned by `src/features/users/` — WP-12's Users section (scoped
 * to the active company), `UserDetailPage`, `UserEditPage`, `AddPersonPage`
 * and `memberActions.tsx` (§ Bedrijfscontext, § Zichtbaarheid). */
export const users = {
  page: {
    title: 'Users',
    noScope: 'You have no administrative scope, so there is no member list to show.',
    departmentListsTitle: 'Department member lists',
    leadCompany: 'Members of {{company}}.',
    membersOf: 'Members of {{company}}',
    companyMembersCardTitle: 'Members',
    addPerson: 'Add person',
    empty: 'No members.',
    name: 'Name',
    email: 'E-mail',
    login: 'Login',
    source: 'Source',
    yes: 'yes',
    no: 'no',
    invitePerson: 'Invite',
    importCsv: 'Import CSV',
    searchPlaceholder: 'Search by name or e-mail…',
    filterDepartment: 'Department',
    allDepartments: 'All departments',
    filterLocation: 'Location',
    allLocations: 'All locations',
    filterStatus: 'Status',
    allStatuses: 'All statuses',
    employee: 'Employee',
    department: 'Department',
    location: 'Location',
    lastSync: 'Last sync',
    consent: 'Consent',
    wearable: 'Wearable',
    pilot: 'Pilot',
    account: 'Account',
    actions: 'Actions',
    accountActive: 'Active',
    accountDeactivated: 'Deactivated',
    noLocation: 'No location',
    noDepartment: 'No department',
    activation: {
      label: 'Activation',
      invited: 'Invited',
      activated: 'Activated',
      active: 'Active',
      inactive: 'Inactive',
      deactivated: 'Deactivated',
    },
    consentStatus: {
      pending: 'Pending',
      confirmed: 'Confirmed',
      declined: 'Withdrawn',
      none: 'None',
    },
  },
  detail: {
    thisPerson: 'this person',
    edit: 'Edit',
    name: 'Name',
    email: 'E-mail',
    nickname: 'Nickname',
    preferredLanguage: 'Preferred language',
    region: 'Region',
    login: 'Login',
    yes: 'yes',
    no: 'no',
    gender: 'Gender',
    birthdate: 'Birthdate',
    height: 'Height',
    weight: 'Weight',
    privateNote:
      'Gender, birthdate, height and weight are private to this person and are not part of anyone else’s view of them.',
    actionsCardTitle: 'Actions',
    statsCardTitle: 'Statistics',
  },
  edit: {
    title: 'Edit personal info',
    lead: 'Name and e-mail come from the sign-in account and cannot be changed here.',
    cancel: 'Cancel',
    save: 'Save',
  },
  addPerson: {
    created: 'Person created.',
    inviteSent: 'An invitation mail is on its way.',
    alreadyHasLogin: 'They already have a login.',
    noLoginYet: 'They have no login yet — you can invite them later from the member list.',
    done: 'Done',
    name: 'Name',
    email: 'E-mail',
    emailHint: 'Optional — with one, the person is invited to sign in.',
    nickname: 'Nickname',
    region: 'Region',
    conflict:
      'A person with this e-mail address already exists{{reason}}. Add that existing person to the scope instead of creating a duplicate.',
    cancel: 'Cancel',
    create: 'Create person',
    companyTitle: 'Add a person to the company',
    departmentTitle: 'Add a person to the department',
    newPersonCardTitle: 'New person',
    existingCardTitle: 'Existing company member',
    existingPersonCardTitle: 'Existing person',
    member: 'Member',
    person: 'Person',
    choose: 'Choose…',
    addToDepartment: 'Add to department',
    addToCompany: 'Add to company',
    searchPeople: 'Search people',
    searchPlaceholder: 'Name or e-mail',
    noEligible: 'No matching person found.',
    editionMismatch:
      "This person's edition differs from the company's. Change the person's or the company's edition first, then try again.",
  },
  actions: {
    invite: 'Invite',
    inviteAgain: 'Invite again',
    changeEmail: 'Change e-mail',
    newEmail: 'New e-mail address',
    save: 'Save',
    cancel: 'Cancel',
    remove: 'Remove',
    unlink: 'Unlink',
    unlinkFromPilot: 'Unlink from pilot',
    erase: 'Erase',
    changeLocation: 'Change location',
    changeDepartment: 'Change department',
    deactivate: 'Deactivate',
    activate: 'Activate',
  },
  invite: {
    title: 'Invite a person',
    name: 'Name',
    email: 'E-mail address',
    role: 'Role',
    roleMember: 'Employee',
    roleAdmin: 'Company admin',
    submit: 'Invite',
    cancel: 'Cancel',
  },
  import: {
    title: 'Import CSV',
    instructions: 'Paste or upload a CSV with columns: name, email, department, location.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Or upload a file',
    submit: 'Import',
    cancel: 'Cancel',
    done: 'Done',
    summary: '{{imported}} imported, {{failed}} failed.',
    rowLabel: 'Row {{row}}',
    rowSuccess: 'Imported',
    rowFailed: 'Failed',
  },
} as const;
